import React from 'react';
import { Chip, Stack } from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

/**
 * Indicador compacto del plan actual + acceso al modal de upgrade.
 * Vive EN LA MISMA FILA que el nombre del workspace (OptimizedChatComponent.js)
 * a propósito -- no debe agregar una fila/altura nueva a esa tarjeta: cada
 * píxel que gana se lo quita a la lista de mensajes del chat.
 * Puramente presentacional -- no hace fetch propio, recibe los datos del
 * plan ya resueltos por el padre (una sola llamada a
 * CreditsEngineService.getLimits() compartida con el resto del panel).
 */
const UpgradePlanBanner = ({ planName, onOpenPlans }) => (
  <Stack direction="row" spacing={1} alignItems="center">
    <Chip
      icon={<WorkspacePremiumIcon sx={{ color: 'var(--wb-orange) !important' }} fontSize="small" />}
      label={`Plan ${planName || 'Free'}`}
      onClick={onOpenPlans}
      clickable
      size="small"
      sx={{
        backgroundColor: 'var(--wb-overlay-08)',
        color: 'var(--wb-text-strong)',
        fontWeight: 600,
        '&:hover': { backgroundColor: 'var(--wb-x-bg-ffffff24, rgba(255,255,255,0.14))' }
      }}
    />
  </Stack>
);

export default UpgradePlanBanner;
